module.exports = __webpack_public_path__ + "img/hdp4.22bce5fd.png";